//import 'prefixfree';
import 'browsernizr/test/touchevents';
import Modernizr from 'browsernizr';
import './jquery';
import './easing';
import './simple-dd';
import './sticky-kit';
import AOS from 'aos';
import './enllax';
import twire from './twire';
import './cycle2';
import './jssocials';
import './ba-outside-events';




'use strict';


/**
 * Cache
 */
var $window			= $(window);
var $document 		= $(document);
var $htmlBody 		= $('html, body');
var $body 			= $('body');
var $header 		= $('header');
var $headers 		= $('header, div.sticky-header');
var $main 			= $('main');
var $footer 		= $('footer');
var $mobileMenu		= $('div.mobile-menu');



/**
 * Run TWire functions
 */
twire.init();


/**
 * Menu highlight
 */
$headers.find('a[href="' + $.escapeSelector(window.location.pathname) + '"]')
       .addClass('active');


/**
 * Drop down
 */
$('header span.drop-down').simpleDD({

	dropdownElement: 'span.child',
	noScriptLink:    '> a'

});


/**
 * Scroll links
 */
$('a[data-scroll-to]').on('click', function(e) {

	e.preventDefault();
	
	$htmlBody.animate({

		scrollTop: $($(this).data('scroll-to')).offset().top - ($body.hasClass('home') === true ? 0 : 65) // $headerHeightMobile if not home

	}, 1000, 'easeInOutExpo');

}).addClass('active');


/**
 * Generate mobile menu
 */
var els = $mobileMenu.data('els');
var menuHTML = '';

for (var counter = 0; counter < els.length; counter ++) {

	var $el = $body.find(els[counter]);

	if ($el.length > 0) {

		menuHTML += $el[0].outerHTML;

	}

}

$mobileMenu.append(menuHTML);

$mobileMenu.find('span.not-in-menu')
           .remove();


/**
 * Menu open; NOTE menu close is not needed since it's a header.clickoutside event
 */
$headers.find('a.menu')
       .on('click', function(e) {

	e.preventDefault();

	$mobileMenu.addClass('active');

	$main.addClass('inactive');
	$footer.addClass('inactive');

});


/**
 * Manage header states on outside click
 */
$headers.on('clickoutside', function() {

	// Revert main and footer
	$main.removeClass('inactive');
	$footer.removeClass('inactive');

	// Close mobile menu
	$mobileMenu.removeClass('active');

});


/**
 * Menu highlight
 */
$headers.find('a[href="' + $.escapeSelector(window.location.pathname) + '"]').addClass('active');
$headers.find('span.drop-down span.child a.active').each(function() {

	$(this).closest('span.drop-down')
	       .children('a')
		   .addClass('active');

});

if ($body.hasClass('blogs') === true || $body.hasClass('blog') === true) {

	$headers.find('a[href^="/blog"]')
	       .addClass('active');

}


/**
 * Async loads
 */
$(async () => {

	// Select
	if ($('select').length > 0) {
		
		await import('./select2');

		$('select').select2({ 
			
			width: '100%', 
			minimumResultsForSearch: -1 
		
		});

	}

	// Slick
	if ($('div[data-slick]').length > 0) {

		await import('./slick');
		
		$('div[data-slick]').slick();

	}

	// Magnific
	if ($('a.lightbox').length > 0 || $('div.gallery').length > 0) {

		await import('./magnific');

		$('a.lightbox.video').magnificPopup({

			type: 'iframe',
			mainClass: 'lightbox-effect',

		});

		$('a.lightbox.inline').magnificPopup({

			type: 'inline',
			mainClass: 'lightbox-effect',

		});

		$('div.gallery').magnificPopup({

			delegate: 'a',
			type: 'image',
			mainClass: 'lightbox-effect',
			gallery: {

				enabled: true,
				navigateByImgClick: true,
				preload: [0,1]

			}

		});

	}

});


/**
 * Site messages
 */
$('div.site-message').each(function() {

	var $this = $(this);

	var icon = 'check';

	if ($this.hasClass('warning') === true) {

		var icon = 'exclamation-circle';

	} else if ($this.hasClass('notice') === true) {

		var icon = 'info-circle';

	} else if ($this.hasClass('error') === true) {

		var icon = 'frown-o';

	}

	$this.append('<a class="fa fa-remove close"></a>')
	     .prepend('<span class="fa fa-' + twire.util.html(icon) + '"></span> ')
	     .find('a.close')
		 .on('click', function(e) {

		$(this).closest('div.site-message')
		       .remove();

	});
	
	if ($this.hasClass('unclosable') === true) {
		
		$this.find('a.close').remove();
		
	}

});


/**
 * Share
 */
$('div.share').each(function() {

	var $share = $(this);

	$share.jsSocials({

	    showLabel: false,
	    showCount: false,
	    shares: [

			'twitter',
			'facebook',
			'pinterest',
			'whatsapp'

		],
		url: $share.data('url')

	});

});


/**
 * AOS
 */
AOS.init();


/**
 * Enllax
 */
$window.enllax();


/**
 * Inspiration
 */
$window.on('load', function() {

	$('body.inspiration').each(function() {

		if (window.location.hash !== '') {

			$('ul.inspiration a[href="' + window.location.hash + '"]').trigger('click');

		}

	});

});


/**
 * Header alt
 */
if ($body.hasClass('home') === true) {

	var $stickyElement = $('div.sticky-header');
	var stickyOffset = $stickyElement.offset().top;

}

$window.on('scroll', function() {

	if ($body.hasClass('home') === true) {

        if ($window.scrollTop() > (stickyOffset + 200)) {

            $stickyElement.addClass('alt');

        } else {

            $stickyElement.removeClass('alt');

        }

	} else {

	    if ($window.scrollTop() > 200) {

	        $header.addClass('alt');

	    } else {

	        $header.removeClass('alt');

	    }

	}

});


/**
 * Add table container
 */
$main.find('table')
     .wrap('<div class="table-container"></div>');

/**
 * Videos
 */
var $videos = $main.find('div.large-banner div.video iframe, div.hero iframe:not(.standard-embed)');

$window.on('resize', function() {

     $videos.each(function() {

		var $this 	= $(this);
		var $parent = $this.closest('div.video');

		// Reset
		$this.css('max-width', '')
			 .css('width', '')
			 .css('height', '')
			 .css('margin-left', '')
			 .css('margin-top', '');

		// Ensures height is correct; ignored if not iframe
		// Otherwise jQuery height() returns the value of the iframe height attribute
		window.twireReflowVideo($this);

		// If the height is under, do it by width
		if ($this.innerHeight() < $parent.innerHeight()) {

			// Set the item auto width and full height
			$this.css('max-width', 'none')
				 .css('width', 'auto')
			     .css('height', $parent.innerHeight()); // was '100%'

			// iframes have no natural width like images so do this manually
			if ($this.prop('tagName').toLowerCase() == 'iframe') {

				$this.css('width', parseInt(($this.height() / 9) * 16) + 'px');

			}

			// Then do the negative left margin
			var marginLeft = ((($this.innerWidth() - $parent.innerWidth()) / 2) * -1);

			marginLeft = (marginLeft > 0) ? 0 : marginLeft;

			$this.css('margin-left', marginLeft);

		} else {

			// This ensure the height of the element is correct
			$this.css('width', '100%');
			//window.cubedReflowVideo($this); // Ensures height is correct; ignored if not iframe

			var marginTop = ((($this.innerHeight() - $parent.innerHeight()) / 2) * -1);

			marginTop = (marginTop > 0) ? 0 : marginTop;

			$this.css('margin-top', marginTop);

		}

	 });

});


/**
 * Projects archive close
 */
function setCookie(name, value, days) {

	let expires = '';

	if (days) {

		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = '; expires=' + date.toUTCString();

	}

	document.cookie = name + '=' + (value || '') + expires + '; path=/';

}

function getCookie(name) {

	const nameEQ = name + '=';
	const ca = document.cookie.split(';');

	for (let i = 0; i < ca.length; i++) {

		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);

	}

	return null;

}

$('div.project-archive-message a.close').on('click', function(e) {

	e.preventDefault();

	setCookie('fll-seen-project-archive-message', 'yes', 30);

	$('div.project-archive-message').remove();

});

if (getCookie('fll-seen-project-archive-message') == 'yes') {

	$('div.project-archive-message a.close').trigger('click');

}

/**
 * Check for Vimeo loading
 */
$window.on('load', function() {

	$main.find('iframe.vimeo')
	     .each(function() {

		var $iframe = $(this);

		var stopOnLoad = $iframe.hasClass('stop-on-load');

		var player = new Vimeo.Player($iframe[0]);

	    player.on('loaded', function() {

			$iframe.addClass('loaded');

			$iframe.closest('div.playable')
			       .find('a.play')
				   .addClass('loaded');

			// Force resize
			$window.trigger('scroll');
			$window.trigger('resize');

			if (stopOnLoad === true) {

				player.pause();

			}

	    });

	});
	
});


/**
 * Play buttons
 */
$main.find('a.play')
     .on('click', function(e) {

	e.preventDefault();

	var $this 	= $(this);
	var $parent = $this.closest('div.playable');
	var $iframe = $parent.find('iframe');

	if ($iframe.length === 1) {

		var player = new Vimeo.Player($iframe[0]);

        player.getPaused().then(function(paused) {

            if (paused === true) {

                player.play();

				$this.addClass('playing');

				$parent.find('div.image')
				       .addClass('inactive');

            } else {

                player.pause();

				$this.removeClass('playing');

				$parent.find('div.image')
				       .removeClass('inactive');

            }

        });

	}

});


/**
 * Projects filter
 */
$('body.projects').each(function() {

	$main.find('div.filters a')
	     .on('click', function(e) {

		e.preventDefault();

		var $a = $(this);

		var $links = $a.closest('div.filters')
		               .find('a');

		var $projects = $main.find('div.project');

		$links.removeClass('active');

		$a.addClass('active');

		$projects.addClass('inactive');

		if ($a.data('filter') == 'all') {

			$projects.removeClass('inactive');

		} else {

			$projects.filter('[data-category-' + $a.data('filter') + ']')
			         .removeClass('inactive');

		}

	});

});


/**
 * More projects
 */
$('body.projects').each(function() {

	$main.find('div.project:not(.active)')
	     .addClass('inactive')
		 .end()
		 .removeClass('active');

	$main.find('div.button a')
	     .on('click', function(e) {

		var $this = $(this);

		e.preventDefault();

		$main.find('div.project')
		     .removeClass('inactive')
		     .addClass('active');

		$this.closest('div.button')
		     .remove();

		$main.find('div.more-projects')
		     .remove();

	});

});


/**
 * Triggers
 */
$window.trigger('scroll'); // Was scroll(), now deprecated, scrolls can be triggered since jQuery 3.3
$window.trigger('resize');